document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("sticky-header.header-wrapper"); // or ".site-header"

  if (!header) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 400) {
      header.classList.add("scrolled-header");
    } else {
      header.classList.remove("scrolled-header");
    }
  });
});